import { ApiService, ConverterService, CryptoProvider } from '../providers/index';
import { CheckPinResult } from '../models';
import { CredentialSalts } from '../types';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AccountDataService {
  protected readonly api = inject(ApiService);
  protected readonly cryptoProvider = inject(CryptoProvider);
  protected readonly converter = inject(ConverterService);

  public async checkIfPinIsValid(pin: string): Promise<CheckPinResult> {
    if (!pin) {
      return {
        success: false,
        message: 'No PIN provided to check',
      };
    }

    const salts = await this.getSalts();

    if (!salts.pinSalt) {
      return {
        success: false,
        message: 'No PIN salt available',
      };
    }

    const pinHashOld = await this.cryptoProvider.computeHash(pin, salts.pinSalt, true);
    const pinHashNew = await this.cryptoProvider.computeHash(pin, salts.pinSalt);
    return firstValueFrom(
      this.api.post('user/validatepin', {
        pinHash: this.converter.uIntArrayToBase64([pinHashOld, pinHashNew]),
      }),
    );
  }

  public getSalts(): Promise<CredentialSalts> {
    return firstValueFrom(
      this.api.restGet<{ passwordSalt: string; pinSalt: string }>('user/salts').pipe(
        map((salts) => ({
          passwordSalt: this.converter.hexStringToUint8Array(salts.passwordSalt),
          pinSalt: salts.pinSalt ? this.converter.hexStringToUint8Array(salts.pinSalt) : null,
        })),
      ),
    );
  }
}
